import { LOGOUT, SAVE_LOGIN_DATA } from '../constants/actions';
import { dispatch } from '../utils/generalUtils';

export function saveLoginDetails(loginData) {
    return dispatch({
        type: SAVE_LOGIN_DATA,
        loginData
    });
}

export function logout() {
    return dispatch({
        type: LOGOUT
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/loginActions.ts